import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './ProjectRecap.css';
import ProjectRecap from './ProjectRecap';

const ProjectRecapWrapper = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [finalVideoUrl, setFinalVideoUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!id) return;

    const fetchProject = async () => {
      setLoading(true);
      setErr(null);

      try {
        const res = await fetch(`/projects/${id}/recap-ui`, {
          headers: { Accept: 'application/json' },
        });

        const ct = res.headers.get('content-type') || '';
        if (!ct.includes('application/json')) {
          const txt = await res.text();
          console.error(
            `[ProjectRecapWrapper] Réponse non JSON pour /projects/${id}/recap-ui (status=${res.status}, type=${ct})`,
            txt.slice(0, 200)
          );
          throw new Error('Réponse invalide du serveur (HTML reçu au lieu de JSON).');
        }

        const data = await res.json();

        if (!res.ok || data?.error || !data?.project) {
          throw new Error(data?.error || `Erreur serveur (${res.status}) lors du chargement du projet.`);
        }

        setProject(data.project);
        setFinalVideoUrl(data.finalVideoUrl || data.videoUrl || '');
      } catch (e) {
        console.error('[ProjectRecapWrapper] Erreur fetch recap-ui:', e);
        setErr(e.message || 'Erreur lors du chargement du projet.');
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [id]);

  if (loading) {
    return (
      <div className="project-recap page-wrap d-flex justify-content-center align-items-center">
        <div className="wv-card p-4" style={{ maxWidth: 520, width: '100%' }}>
          <div className="d-flex align-items-center gap-3">
            <div className="spinner-border text-primary" role="status" aria-label="Chargement" />
            <div>
              <div className="fw-semibold">Chargement du récapitulatif…</div>
              <div className="text-muted small">Veuillez patienter</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (err) {
    return (
      <div className="project-recap page-wrap">
        <div className="container" style={{ maxWidth: 820 }}>
          <div className="alert alert-danger rounded-4 d-flex align-items-start gap-2" role="alert">
            <i className="bi bi-x-octagon-fill fs-5"></i>
            <div>
              <div className="fw-semibold">Impossible de charger le récapitulatif du projet.</div>
              <div className="small text-muted">{err}</div>
            </div>
          </div>

          <a href="/dashboard" className="btn btn-outline-secondary rounded-pill px-3 w-auto text-nowrap d-inline-flex align-items-center gap-2">
            <i className="bi bi-arrow-left"></i>
            Retour au tableau de bord
          </a>
        </div>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="project-recap page-wrap">
        <div className="container" style={{ maxWidth: 820 }}>
          <div className="alert alert-warning rounded-4 d-flex align-items-center gap-2" role="alert">
            <i className="bi bi-exclamation-triangle-fill"></i>
            <span>Projet introuvable.</span>
          </div>

          <a href="/dashboard" className="btn btn-outline-secondary rounded-pill px-3 w-auto text-nowrap d-inline-flex align-items-center gap-2">
            <i className="bi bi-arrow-left"></i>
            Retour au tableau de bord
          </a>
        </div>
      </div>
    );
  }

  return <ProjectRecap project={project} finalVideoUrl={finalVideoUrl} />;
};

export default ProjectRecapWrapper;
